import type { EChartsExtensionInstallRegisters } from 'echarts';
import TooltipView from 'echarts/lib/component/tooltip/TooltipView';
import { noop } from 'zrender/lib/core/util';

export function tooltipExtensionInstall(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterinit', () => {
    class TooltipViewPlus extends TooltipView {
      dvImmediatelyHideTip() {
        const tooltipContent = this._tooltipContent;
        tooltipContent.hide();
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
      }
    }
    registers.registerAction(
      {
        type: 'dvImmediatelyHideTip',
        event: 'dvImmediatelyHideTip',
        update: 'tooltip:dvImmediatelyHideTip'
      },
      noop
    );

    registers.registerComponentView(TooltipViewPlus);
  });
}
